import { GqlAuthorizationGroup, GqlMeeting, GqlMeetingKind } from '../../../../graphql/base-types.graphql';
import { HandleCreateMeetingFn, StepMeeting } from '../../../common/components/StepMeeting';
import {
  useAgCreateMeetingMutation,
  useAgConnectMeetingMutation,
  useAgDisconnectMeetingMutation,
} from '../../../../graphql/react-operations';
import { Stack } from '@startuptools/ui/Stack';
import { Box } from '@startuptools/ui/Box';
import { Button } from '@startuptools/ui/Button';
import { Trans } from '@lingui/react';
import { DisplayDocument } from '@startuptools/business-ui/document/Document';
import { useStepper } from '../../../../components/steppers/common/StepperContext';
import { AuthorizationDocument } from '../../Authorization.graphql';

export const AgStepMeeting = ({
  authorizationGroup,
  meeting,
  hasActiveSubscription,
}: {
  authorizationGroup: Pick<GqlAuthorizationGroup, 'id' | 'companyId'>;
  meeting:
    | (Pick<GqlMeeting, 'id' | 'kind' | 'number' | 'heldKind' | 'startTime' | 'usesStepper'> & {
        latestMinutesDocument?: DisplayDocument | null;
      })
    | null
    | undefined;
  hasActiveSubscription: boolean;
}) => {
  const [doCreate, { loading: loadingCreate }] = useAgCreateMeetingMutation({
    refetchQueries: [AuthorizationDocument],
    awaitRefetchQueries: true,
  });
  const [doConnect, { loading: loadingConnect }] = useAgConnectMeetingMutation({
    refetchQueries: [AuthorizationDocument],
    awaitRefetchQueries: true,
  });
  const [doDisconnect, { loading: loadingDisconnect }] = useAgDisconnectMeetingMutation({
    refetchQueries: [AuthorizationDocument],
    awaitRefetchQueries: true,
  });
  const { stepNext } = useStepper();

  const allowMeetingKinds = [GqlMeetingKind.ExtraShareholdersMeeting, GqlMeetingKind.ShareholdersMeeting];

  const handleCreateMeeting: HandleCreateMeetingFn = ({ endTime, startTime, ...values }) => {
    return doCreate({
      variables: {
        companyId: authorizationGroup.companyId,
        input: {
          id: authorizationGroup.id,
          meetingCreate: {
            startTime: startTime.toUTC(0, { keepLocalTime: true }).toString(),
            endTime: endTime?.toUTC(0, { keepLocalTime: true }).toString(),
            ...values,
          },
        },
      },
    });
  };

  return (
    <Stack gap={3}>
      <StepMeeting
        loadingStates={{
          create: loadingCreate,
          connect: loadingConnect,
          disconnect: loadingDisconnect,
        }}
        meeting={meeting}
        snrAuth={null}
        allowMeetingKinds={allowMeetingKinds}
        hasActiveSubscription={hasActiveSubscription}
        handleCreateMeeting={handleCreateMeeting}
        handleConnectMeeting={meetingId =>
          doConnect({
            variables: { companyId: authorizationGroup.companyId, input: { id: authorizationGroup.id, meetingId } },
          })
        }
        handleDisconnectMeeting={() =>
          doDisconnect({ variables: { companyId: authorizationGroup.companyId, input: { id: authorizationGroup.id } } })
        }
        handleSelectAuth={null}
        handleDisconnectAuth={null}
      />

      <Box>
        <Button onClick={() => stepNext()}>
          <Trans id="Continue" />
        </Button>
      </Box>
    </Stack>
  );
};
